import { isMobile, isTablet } from 'react-device-detect';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
	width: 100%;
	font-family: 'poppins-regular';
	margin-top: ${!isMobile && !isTablet ? '2vh' : '1vh'};
	.features {
		display: flex;
		justify-content: center;
		flex-direction: ${!isMobile && !isTablet ? 'row' : 'column'};

		@media only screen and (min-width: 667px) {
			flex-direction: row;
			justify-content: ${!isMobile && !isTablet ? 'center' : 'space-around'};
		}
	}
`;

export const ContentContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	/* margin: 0 0 20px 0; */
`;

export const ContentTitle = styled.div`
	color: #71b2ee;
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 28px)` : '3.5vw'};
	font-family: 'poppins-bold';
	text-align: center;
	text-transform: uppercase;
`;

export const ContentDesctiption = styled.div`
	color: #dee0ef;
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 20px)` : '2.4vw'};
	font-family: 'poppins-regular';
	text-align: center;
	width: ${!isMobile && !isTablet ? '60%' : '70%'};
	margin: auto;
`;
export const ContentDesctiptionBonus = styled.div`
	color: #dee0ef;
	font-size: ${(p) =>
		p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 20px)` : '2.4vw'};
	font-family: 'poppins regular';
	text-align: center;
	width: ${!isMobile && !isTablet ? '90%' : '90%'};
	margin: ${(p) =>
		p.scale && !isMobile && !isTablet
			? `calc(${p.scale} * 2vh) auto`
			: `calc(${p.scale} * 20vh) auto`};
	line-height: 1.6;
	.yellow {
		color: #ceee71;
	}
	.blue {
		color: #3ba4f0;
	}
	.purple {
		color: #4559eb;
	}
	.pink {
		color: #fa7394;
	}
	span {
		img {
			vertical-align: middle;
			width: ${(p) =>
				p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 26px)` : `20px`};
		}
	}
	.bet-amount-wrapper {
		display: ${!isMobile && !isTablet ? 'flex' : 'unset'};
		justify-content: center;
		align-items: center;
	}
	.bet-amount {
		display: flex;
		flex-direction: column;
		width: fit-content;
		align-items: flex-start;
		background: linear-gradient(
			106.83deg,
			rgba(43, 93, 169, 0.2) 2.07%,
			rgba(10, 57, 126, 0.2) 102.38%
		);
		border: 0.67px solid #1a2870;
		border-radius: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 8px)`
				: `calc(${p.scale} * 8px)`};
		padding: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 5px) calc(${p.scale} * 10px)`
				: `5px 10px`};
		margin: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} * 5px) `
				: `calc(${p.scale} * 10px) auto`};
		line-height: 1;
		font-family: 'Poppins Semibold';
		.bet {
			font-size: ${(p) =>
				p.scale && !isMobile && !isTablet
					? `calc(${p.scale} * 10px)`
					: `1.6vw`};
			color: #7571ca;
			text-transform: uppercase;
		}
		.amount {
			color: #cbcaea;
			font-size: ${(p) =>
				p.scale && !isMobile && !isTablet ? `calc(${p.scale} * 12px)` : `2vw`};
		}
	}
`;

export const ContentItem = styled.div`
	display: flex;
	align-items: center;
	flex: ${!isMobile && !isTablet ? `0 0 25%` : '0 0 40%'};
	justify-content: center;
	@media only screen and (min-width: 768px) {
		flex: ${(p) =>
			!isMobile && !isTablet
				? `0 0 ${p.name && p.name === 'additional_symbols' ? '35%' : '25%'}`
				: `0 0 ${p.name && p.name === 'additional_symbols' ? '35%' : '30%'}`};
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: ${(p) =>
		p.name && p.name === 'additional_symbols' ? 'space-between' : 'center'};
	margin-bottom: 20px;
	width: 90%;
	margin: 2vh auto;
`;

export const ImageBox = styled.div`
	flex: ${(p) => (p.name ? '0 0 18%' : '0 0 15%')};
	margin: auto;
	img {
		width: 100%;
	}
	&&.progressive {
		img {
			width: 90%;
		}
	}
	&&.progressive:nth-child(1),
	&&.progressive:nth-child(2),
	&&.progressive:nth-child(4) {
		text-align: center;
		img {
			width: 70%;
		}
	}
	&&.progressive:nth-child(1) {
		transform: translateY(10px);
	}
	&&.progressive:nth-child(4) {
		transform: translateY(10px);
	}
	&&.game-interface {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1vw;
		flex: 0 0 10%;
		img {
			max-height: 67px;
			width: 80%;
		}
		p {
			color: #dee0ef;
			font-family: 'poppins-bold';
			text-wrap: nowrap;
			font-size: ${!isMobile && !isTablet ? `1vw` : '2.16vw'};
		}
	}
`;
export const Icon = styled.div`
	width: 40%;
	img {
		width: 100%;
	}
`;
export const Payouts = styled.div`
	line-height: 1.33;
	flex-direction: column-reverse;
	display: flex;
	span {
		color: #43b726;
		font-size: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} *  ${p.name && p.name === 'additional_symbols' ? '24px' : '18px'})`
				: '2.16vw'};
		margin-right: 4px;
		flex: 0 0 15%;
		text-align: right;
	}
	p {
		color: #dee0ef;
		font-size: ${(p) =>
			p.scale && !isMobile && !isTablet
				? `calc(${p.scale} *  ${p.name && p.name === 'additional_symbols' ? '24px' : '18px'})`
				: '2.16vw'};
		flex: 0 0 85%;
		text-align: left;
	}
`;

export const Payout = styled.div`
	display: flex;
	p {
		white-space: nowrap;
	}
`;
export const FeatureBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1vw;
	flex: 0 0 40%;
`;
